"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core = __importStar(require("@actions/core"));
const context = __importStar(require("./context"));
const git = __importStar(require("./git"));
const gpg = __importStar(require("./gpg"));
const openpgp = __importStar(require("./openpgp"));
const stateHelper = __importStar(require("./state-helper"));
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const inputs = yield context.getInputs();
            if (inputs.workdir && inputs.workdir !== '.') {
                core.info(`Using ${inputs.workdir} as working directory...`);
                process.chdir(inputs.workdir);
            }
            const version = yield gpg.getVersion();
            const dirs = yield gpg.getDirs();
            yield core.group(`GnuPG info`, () => __awaiter(this, void 0, void 0, function* () {
                core.info(`Version    : ${version.gnupg} (libgcrypt ${version.libgcrypt})`);
                core.info(`Libdir     : ${dirs.libdir}`);
                core.info(`Libexecdir : ${dirs.libexecdir}`);
                core.info(`Datadir    : ${dirs.datadir}`);
                core.info(`Homedir    : ${dirs.homedir}`);
            }));
            const privateKey = yield openpgp.readPrivateKey(inputs.gpgPrivateKey);
            yield core.group(`GPG private key info`, () => __awaiter(this, void 0, void 0, function* () {
                core.info(`Fingerprint  : ${privateKey.fingerprint}`);
                core.info(`KeyID        : ${privateKey.keyID}`);
                core.info(`Name         : ${privateKey.name}`);
                core.info(`Email        : ${privateKey.email}`);
                core.info(`CreationTime : ${privateKey.creationTime}`);
            }));
            stateHelper.setFingerprint(privateKey.fingerprint);
            let fingerprint = privateKey.fingerprint;
            if (inputs.fingerprint) {
                fingerprint = inputs.fingerprint;
            }
            yield core.group(`Fingerprint to use`, () => __awaiter(this, void 0, void 0, function* () {
                core.info(fingerprint);
            }));
            yield core.group(`Importing GPG private key`, () => __awaiter(this, void 0, void 0, function* () {
                yield gpg.importKey(inputs.gpgPrivateKey).then(stdout => {
                    core.info(stdout);
                });
            }));
            if (inputs.passphrase) {
                yield core.group(`Configuring GnuPG agent`, () => __awaiter(this, void 0, void 0, function* () {
                    const gpgHome = yield gpg.getHome();
                    core.info(`GnuPG home: ${gpgHome}`);
                    yield gpg.configureAgent(gpgHome, gpg.agentConfig);
                }));
                if (!inputs.fingerprint) {
                    // Set the passphrase for all subkeys
                    yield core.group(`Getting keygrips`, () => __awaiter(this, void 0, void 0, function* () {
                        for (const keygrip of yield gpg.getKeygrips(fingerprint)) {
                            core.info(`Presetting passphrase for ${keygrip}`);
                            yield gpg.presetPassphrase(keygrip, inputs.passphrase).then(stdout => {
                                core.debug(stdout);
                            });
                        }
                    }));
                }
                else {
                    // Set the passphrase only for the subkey specified in the input `fingerprint`
                    yield core.group(`Getting keygrip for fingerprint`, () => __awaiter(this, void 0, void 0, function* () {
                        const keygrip = yield gpg.getKeygrip(fingerprint);
                        core.info(`Presetting passphrase for key ${fingerprint} with keygrip ${keygrip}`);
                        yield gpg.presetPassphrase(keygrip, inputs.passphrase).then(stdout => {
                            core.debug(stdout);
                        });
                    }));
                }
            }
            if (inputs.trustLevel) {
                yield core.group(`Setting key's trust level`, () => __awaiter(this, void 0, void 0, function* () {
                    yield gpg.setTrustLevel(privateKey.keyID, inputs.trustLevel).then(() => {
                        core.info(`Trust level set to ${inputs.trustLevel} for ${privateKey.keyID}`);
                    });
                }));
            }
            yield core.group(`Setting outputs`, () => __awaiter(this, void 0, void 0, function* () {
                core.info(`fingerprint=${fingerprint}`);
                core.setOutput('fingerprint', fingerprint);
                core.info(`keyid=${privateKey.keyID}`);
                core.setOutput('keyid', privateKey.keyID);
                core.info(`name=${privateKey.name}`);
                core.setOutput('name', privateKey.name);
                core.info(`email=${privateKey.email}`);
                core.setOutput('email', privateKey.email);
            }));
            if (inputs.gitUserSigningkey) {
                core.info('Setting GPG signing keyID for this Git repository');
                yield git.setConfig('user.signingkey', privateKey.keyID, inputs.gitConfigGlobal);
                const userEmail = inputs.gitCommitterEmail || privateKey.email;
                const userName = inputs.gitCommitterName || privateKey.name;
                if (userEmail != privateKey.email) {
                    core.setFailed(`Committer email "${inputs.gitCommitterEmail}" (name: "${inputs.gitCommitterName}") does not match GPG private key email "${privateKey.email}" (name: "${privateKey.name}")`);
                    return;
                }
                core.info(`Configuring Git committer (${userName} <${userEmail}>)`);
                yield git.setConfig('user.name', userName, inputs.gitConfigGlobal);
                yield git.setConfig('user.email', userEmail, inputs.gitConfigGlobal);
                if (inputs.gitCommitGpgsign) {
                    core.info('Sign all commits automatically');
                    yield git.setConfig('commit.gpgsign', 'true', inputs.gitConfigGlobal);
                }
                if (inputs.gitTagGpgsign) {
                    core.info('Sign all tags automatically');
                    yield git.setConfig('tag.gpgsign', 'true', inputs.gitConfigGlobal);
                }
                if (inputs.gitPushGpgsign) {
                    core.info('Sign all pushes automatically');
                    yield git.setConfig('push.gpgsign', inputs.gitPushGpgsign, inputs.gitConfigGlobal);
                }
            }
        }
        catch (error) {
            core.setFailed(error.message);
        }
    });
}
function cleanup() {
    return __awaiter(this, void 0, void 0, function* () {
        if (stateHelper.fingerprint.length <= 0) {
            core.debug('Primary key fingerprint is not defined. Skipping cleanup.');
            return;
        }
        try {
            core.info(`Removing key ${stateHelper.fingerprint}`);
            yield gpg.deleteKey(stateHelper.fingerprint);
            core.info('Killing GnuPG agent');
            yield gpg.killAgent();
        }
        catch (error) {
            core.warning(error.message);
        }
    });
}
if (!stateHelper.IsPost) {
    run();
}
else {
    cleanup();
}
